import {logEvent, setUserProperties, setUserId} from 'firebase/analytics';

import {analytics} from '../../setupFirebase';

export const analyticsService = {
  // Eventos de página
  trackPageView(pageName) {
    if (!analytics) return;
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href
    });
  },

  // Eventos de interação
  trackButtonClick(buttonName, location) {
    if (!analytics) return;
    logEvent(analytics, 'button_click', {
      button_name: buttonName,
      button_location: location
    });
  },

  // Eventos de credenciamento
  trackAccreditationStart() {
    if (!analytics) return;
    logEvent(analytics, 'accreditation_start', {
      event_category: 'engagement',
      event_label: 'credenciamento_iniciado'
    });
  },

  trackAccreditationComplete() {
    if (!analytics) return;
    logEvent(analytics, 'accreditation_complete', {
      event_category: 'conversion',
      event_label: 'credenciamento_finalizado'
    });
  },

  trackAccreditationAbandoned() {
    if (!analytics) return;
    logEvent(analytics, 'accreditation_abandoned', {
      event_category: 'engagement',
      event_label: 'credenciamento_abandonado'
    });
  },

  // Eventos de sistema
  trackMaintenanceView() {
    if (!analytics) return;
    logEvent(analytics, 'maintenance_view', {
      event_category: 'system',
      event_label: 'modo_manutencao_exibido'
    });
  },

  // Eventos de termos e políticas
  trackPrivacyPolicyView() {
    if (!analytics) return;
    logEvent(analytics, 'privacy_policy_view', {
      event_category: 'engagement',
      event_label: 'politica_privacidade_visualizada'
    });
  },

  trackTermsModalView(tabName) {
    if (!analytics) return;
    logEvent(analytics, 'terms_modal_view', {
      event_category: 'engagement',
      event_label: `termos_${tabName}_visualizado`
    });
  },

  // A/B Testing
  trackExperiment(experimentId, variantId) {
    if (!analytics) return;
    logEvent(analytics, 'experiment_impression', {
      experiment_id: experimentId,
      variant_id: variantId
    });
  },

  // Propriedades do usuário
  setUserProperty(propertyName, value) {
    if (!analytics) return;
    setUserProperties(analytics, {
      [propertyName]: value
    });
  },

  // ID do usuário
  setUser(userId) {
    if (!analytics) return;
    setUserId(analytics, userId);
  }
};
